import React from "react";
import BiasGraphic from "./BiasGraphic";

export default function ConfluenceRing({ analysis }) {
  const ring = analysis?.ring || { long: 33, short: 33, neutral: 34 };
  const conf = analysis?.confluence ?? 0;
  const bias = analysis?.bias || "—";
  const cats = analysis?.categories || [];

  const R = 78, C = 2 * Math.PI * R, sw = 14;
  const segs = [
    { v: ring.long, color: "#22c55e" },
    { v: ring.neutral, color: "#3f3f46" },
    { v: ring.short, color: "#ef4444" },
  ];
  let offset = 0;
  const arcs = segs.map((s, idx) => {
    const len = (s.v / 100) * C;
    const el = (
      <circle key={idx} cx="100" cy="100" r={R} fill="none" stroke={s.color} strokeWidth={sw}
        strokeDasharray={`${len} ${C - len}`} strokeDashoffset={-offset} strokeLinecap="butt"
        transform="rotate(-90 100 100)" style={{ transition: "stroke-dasharray .6s ease" }} />
    );
    offset += len;
    return el;
  });

  const biasColor = bias.includes("BULL") ? "#22c55e" : bias.includes("BEAR") ? "#ef4444" : "#a78bfa";

  return (
    <div className="ym-panel p-4 relative overflow-hidden grain">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-[13px] font-bold">Konfluensi Pasar</h3>
        <span className="pill" style={{ color: "var(--accent-soft)", background: "rgba(139,92,246,.12)", borderColor: "transparent" }}>
          {analysis?.direction || "—"}
        </span>
      </div>

      <div className="relative grid place-items-center py-1">
        {/* low-opacity watermark bias graphic behind ring */}
        <div className="absolute inset-0 grid place-items-center opacity-[0.08] pointer-events-none">
          <BiasGraphic direction={analysis?.direction} size={120} />
        </div>
        <svg width="200" height="200" viewBox="0 0 200 200">
          <circle cx="100" cy="100" r={R} fill="none" stroke="var(--border)" strokeWidth={sw} />
          {arcs}
        </svg>
        <div className="absolute flex flex-col items-center">
          <div className="text-[30px] font-extrabold tabnum leading-none">{conf}<span className="text-[16px]" style={{ color: "var(--text-dim)" }}>/100</span></div>
          <div className="text-[11px] font-bold mt-1 tracking-wide" style={{ color: biasColor }}>{bias}</div>
        </div>
      </div>

      {/* legend */}
      <div className="flex items-center justify-center gap-4 mt-1 mb-3 text-[10px]">
        <Legend color="#22c55e" label="Long" v={ring.long} />
        <Legend color="#3f3f46" label="Neutral" v={ring.neutral} />
        <Legend color="#ef4444" label="Short" v={ring.short} />
      </div>

      <div className="divider mb-2.5" />

      {/* categories */}
      <div className="space-y-2">
        {cats.map((c) => (
          <div key={c.key} className="flex items-center gap-2.5">
            <span style={{ width: 8, height: 8, borderRadius: 3, background: c.color, display: "inline-block" }} />
            <span className="text-[12px]" style={{ color: "var(--text-muted)" }}>{c.label}</span>
            {(c.status === "demo" || c.status === "unavailable") && <span className="pill" style={{ fontSize: 8, padding: "1px 6px", color: "var(--amber)", background: "rgba(245,158,11,.12)", borderColor: "transparent" }}>{c.status === "unavailable" ? "N/A" : "DEMO"}</span>}
            <div className="ml-auto flex items-center gap-2 w-28">
              <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ background: "var(--panel-2)" }}>
                <div className="h-full rounded-full" style={{ width: `${c.score ?? 0}%`, background: c.color, transition: "width .5s ease" }} />
              </div>
              <span className="text-[11px] font-bold tabnum w-7 text-right" style={{ color: c.score != null ? "var(--text)" : "var(--text-dim)" }}>{c.score ?? "—"}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Legend({ color, label, v }) {
  return (
    <div className="flex items-center gap-1.5">
      <span style={{ width: 8, height: 8, borderRadius: 3, background: color }} />
      <span style={{ color: "var(--text-muted)" }}>{label}</span>
      <span className="tabnum font-bold" style={{ color: "var(--text)" }}>{v}%</span>
    </div>
  );
}
